export const coreUrl = 'https://squid-api.tjek.com';
export const coreUrlStaging = 'https://squid-api.tjek-staging.com';
export const eventsTrackUrl = 'https://wolf-api.tjek.com/sync';
export const eventsTrackUrlStaging = 'https://wolf-api.tjek-staging.com/sync';
